import {
    FunctionComponent,
    PropsWithChildren,
    useEffect,
    useState,
} from 'react';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIsAuthorized } from '@/hooks/useIsAuthorized';
import UnAuthorizedPage from '@/pages/UnAuthorizedPage';

export const AuthGuard: FunctionComponent<PropsWithChildren> = ({
    children,
}) => {
    const { isLoggedIn, getAuthDataFromLocalStorage, logoutType } =
        useAuthentication();
    const navigate = useNavigate();
    const location = useLocation();
    const [localAuthCheckDone, setLocalAuthCheckDone] = useState(false);
    const [isAuthorized] = useIsAuthorized([]);

    useEffect(() => {
        getAuthDataFromLocalStorage();
        setLocalAuthCheckDone(true);
    }, []);

    // Check if route requires authentication (all routes except /login are protected)
    const isProtectedRoute = location.pathname !== '/login';

    if (localAuthCheckDone) {
        const redirectToLogin = isProtectedRoute && !isLoggedIn();
        if (redirectToLogin) {
            const redirectPath =
                logoutType !== 'userLogout'
                    ? `/login?redirectUrl=${encodeURIComponent(
                          `${location.pathname}${location.search}`
                      )}`
                    : '/login';
            navigate(redirectPath);
            return null;
        }

        if (isProtectedRoute && !isAuthorized) {
            return <UnAuthorizedPage />;
        }
    }

    return localAuthCheckDone ? <>{children}</> : null;
};
